// Directly copied from https://gist.github.com/dtarnawsky/fc92869c1c67b9c74c66de8af3e081b2
// At the advice of
//  https://capacitorjs.com/docs/guides/autofill-credentials
//  https://bugs.webkit.org/show_bug.cgi?id=226023

import { Directive, ElementRef, OnInit } from "@angular/core";
import { Capacitor } from "@capacitor/core";

@Directive({
  selector: "[appAutofill]",
})
export class AutofillDirective implements OnInit {
  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    if (Capacitor.getPlatform() !== "ios") {
      return;
    }
    setTimeout(() => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        this.el.nativeElement.children[0].addEventListener("change", (e: any) => {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          this.el.nativeElement.value = e.target.value;
        });
      } catch {
        (() => {})();
      }
    }, 100); // Need some time for the ion-input to create the input element
  }
}
